// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__4GDd4","icon":"SortAdornment_icon__2XuBy","up":"SortAdornment_up__3PKHS","down":"SortAdornment_down__2RgTi","active":"SortAdornment_active__2fvWZ"};